import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { shallowEqual, useSelector } from 'react-redux';

import { useHeaderState } from '../../../contexts/HeaderContext';

import { navigationItems } from '../../../domain/home/navigationItems';
import { aiAssistantColors } from '../../../domain/ragChat/theme';

import { HEADER_HEIGHT } from '../../../consistents';
import { favoritesSelector } from '../../../redux/ui/settingsFavorites';
import { gaClickEvent } from '../../../utils/googleAnalytics';
import { Logo } from '../../atoms/Icon/Logo';
import { LogoSymbolOnly } from '../../atoms/Icon/LogoSymbolOnly';
import { Tooltip } from '../../atoms/Tooltip/Tooltip';
import { GlobalFavoritesNavigation } from './GlobalFavoritesNavigation';
import { GlobalNavigationItem } from './GlobalNavigationItem';
import { GlobalNavigationSettingItem } from './GlobalNavigationSettingItem';

type Props = {
  onToggleAiAssistant: (isOpen: boolean) => void;
  isOpenAiAssistant: boolean;
};

export const GlobalNavigation = (props: Props) => {
  const favorite = useSelector(favoritesSelector, shallowEqual);
  const { isOpenMenu } = useHeaderState();
  const { onToggleAiAssistant, isOpenAiAssistant } = props;

  return (
    <Box>
      <Box
        sx={{
          overflow: 'hidden',
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          noWrap
          sx={{
            display: 'flex',
            overflow: 'auto',
            alignItems: 'center',
            width: '260px',
            height: HEADER_HEIGHT,
            ml: isOpenMenu ? '16px' : '8px',
            '& > svg': { height: '36px', width: 'auto' },
            transition: (theme) =>
              theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
          }}
        >
          {isOpenMenu ? <Logo /> : <LogoSymbolOnly />}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          px: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Tooltip
            arrow
            title="AIアシスタント"
            disableHoverListener={isOpenMenu}
            placement="right"
            disableTouchListener
            disableInteractive={false}
          >
            <Button
              // ガイド用のクラス名を追加
              className="joyride-global-nav-button"
              variant="contained"
              sx={{
                minWidth: '100%',
                minHeight: '45px',
                background: aiAssistantColors.background,
              }}
              onClick={() => {
                onToggleAiAssistant(!isOpenAiAssistant);
                gaClickEvent('AIアシスタント表示/非表示', {
                  event_click_state: !isOpenAiAssistant ? 'ON' : 'OFF',
                });
              }}
            >
              <AutoAwesomeIcon />
              {isOpenMenu ? (
                <Box
                  sx={{
                    px: 2,
                    fontSize: '1rem',
                    fontWeight: 'bold',
                  }}
                >
                  AIアシスタント
                </Box>
              ) : null}
            </Button>
          </Tooltip>
        </Box>
      </Box>
      <List>
        {navigationItems.map((item) => (
          <GlobalNavigationItem
            key={item.href}
            name={item.name}
            href={item.href}
            hasFavorite={item.hasFavorite}
            decorationIcon={item.decorationIcon}
          />
        ))}

        {/*  システム設定 */}
        <GlobalNavigationSettingItem />

        {/*  お気に入り */}
        <GlobalFavoritesNavigation
          favoriteList={favorite?.favorites}
          isOpenMenu={isOpenMenu}
        />
      </List>
    </Box>
  );
};
